export default "__VITE_ASSET__D5nD8wtj__"